module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10038.35fc9ed7.jpg";